// extracted by mini-css-extract-plugin
export var infoRow = "_ri-2";
export var labelContainer = "_ri-0";
export var rightInfo = "_ri-1";